import type {
  GuesteriaPartnerCategoryId,
  GuesteriaPartnerConnectionStatus,
  GuesteriaPartnerRow,
} from "./guesteriaPartnersModel";

export type GuesteriaPartnersFiltersState = {
  searchQuery: string;
  categories: GuesteriaPartnerCategoryId[];
  connectionStatuses: GuesteriaPartnerConnectionStatus[];
};

export const DEFAULT_GUESTERIA_PARTNERS_FILTERS: GuesteriaPartnersFiltersState =
  {
    searchQuery: "",
    categories: [],
    connectionStatuses: [],
  };

export const GUESTERIA_PARTNER_CATEGORY_OPTIONS: readonly GuesteriaPartnerCategoryId[] =
  ["tour", "museum", "trip", "art"] as const;

export const GUESTERIA_PARTNER_CONNECTION_OPTIONS: readonly GuesteriaPartnerConnectionStatus[] =
  ["installed", "unavailable"] as const;

export function filterGuesteriaPartnerRows(
  rows: GuesteriaPartnerRow[],
  filters: GuesteriaPartnersFiltersState,
): GuesteriaPartnerRow[] {
  const q = filters.searchQuery.trim().toLowerCase();
  return rows.filter(
    (row) =>
      (!q || row.name.toLowerCase().includes(q)) &&
      (filters.categories.length === 0 ||
        filters.categories.includes(row.category)) &&
      (filters.connectionStatuses.length === 0 ||
        filters.connectionStatuses.includes(row.connectionStatus)),
  );
}

export function countActiveGuesteriaFilters(
  filters: GuesteriaPartnersFiltersState,
): number {
  return (
    filters.categories.length +
    filters.connectionStatuses.length +
    (filters.searchQuery.trim() ? 1 : 0)
  );
}
